<template>
    <!-- Withdraw Password Modal -->
    <div class="modal fade worli-Bets-Modal forgot-password-modal bonus-point-modal" ref="withdraw" id="withdrawalPassword" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header border-blow">
                    <h3 class="modal-title">{{  $t('forgot-withdraw-password','Forgot Withdraw Password') }}</h3>
                    <button  @click="$helper.closeModal('withdrawalPassword'), resetWithdrawForm();" type="button" class="btn-close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="withdraw-password-update">
                        <div class="otp-msg-show">{{ $t('otp-sent-to', 'OTP sent to') }} <strong>****** {{ $auth?.user?.phone?.slice(-4) }}</strong>.</div>
                        <div class="withdraw-instruction">
                            <h4>{{ $t('withdraw-instruction', 'Withdraw Instructions') }}</h4>
                            <ul>
                                <li>{{ $t('withdraw-password-eight-twenty', 'Withdraw Password Must be of minimum 8 characters and maximum 20 characters required') }}</li>
                                <li>{{ $t('withdraw-password-small-capital', 'Withdraw Password Must have atleast 1 small and 1 capital alphabet') }}</li>
                                <li>{{ $t('withdraw-password-digit-special-char', 'Withdraw Password Must have atleast 1 Digit and 1 Special character') }}</li>
                                <li>{{ $t('please-take-note-your-withdraw-password', 'Please take a note of your Withdraw Password') }}</li>
                            </ul>
                        </div>
                       
                        <div class="acc-login-form-sec mt-3">
                            <label for="">{{ $t('enter-withdrawal-otp', 'Enter Withdrawal OTP') }} <span class="text-danger">*</span></label>
                            <div class="withdraw-otp-row">
                                <input type="tel" v-model="withdraw.otp"  maxlength="6"  class="form-control add" 
                                    :class="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0 ? 'error-input': ''" 
                                    @input="withdraw.otp = $helper.sanitizeNumber(withdraw.otp, 999999); validate() " />   
                                    <span class="asterisk" v-if="!withdraw.otp">{{ $t('enter-otp','Enter OTP') }}</span>                         
                                <button type="button" class="otp-resend pass_otp_btn"> 
                                    <span v-if="(minutes > 0 || seconds > 0) && !isResentOtpBtnVisiable">{{ minutes }}:{{ seconds }}</span> 
                                    <span class="change_pass_otp_btn" v-if="isResentOtpBtnVisiable" @click="resendOtp()">{{ $t('resend-otp', 'Resend OTP') }}</span>
                                </button>
                            </div>
                                <section class="add_account_error_messege" v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.otp" :key="index">
                                        <p class="wallet-error">&#x2022; {{ $t(err.lang, err.error) }}</p>
                                    </section>
                                </section>
                                <!-- <p class="size-of-box resend-otp"> 
                                    <span class="red text-bold" v-if="minutes > 0 || seconds > 0">{{ $t('otp-expire-in', 'OTP Expire In') }} {{ minutes }}:{{ seconds }}</span> 
                                    <button v-if="isResentOtpBtnVisiable" @click="resendOtp()" class="btn link-btn resend-otp-link">{{ $t('resend-otp', 'Resend OTP') }}</button>
                                </p> -->                            
                        </div>
                        <div class="acc-login-form-sec">
                            <label for="">{{ $t('withDraw-password', 'Withdraw Password') }} <span class="text-danger">*</span></label>
                            <div class="password-field-rel">
                                <input v-model="withdraw.password" :type="oldPasswordFieldType"  class="form-control add password-input" 
                                    @input="withdraw.password = $helper.sanitizeDetails('withdrawPassword', withdraw.password, 20); validate()" 
                                    :class="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0 ? 'error-input':!withdraw.password?'Zindex' : ''" />
                                    <span class="asterisk" v-if="!withdraw.password">{{ $t('enter-withdraw-password', 'Enter Withdraw Password') }}</span>

                                <div class="showHide-pass withdraw_pass" @click="togglePasswordVisibility('oldPassword')">
                                    <img v-if="oldPasswordFieldType === 'password'" src="@/assets/images/hide-pasword.webp" alt="show-pass" loading="lazy"/>
                                    <img v-else src="@/assets/images/show-pasword.webp" alt="show-pass"  loading="lazy"/>
                                    <!-- <i @click="togglePasswordVisibility('oldPassword')" class="fa-solid" :class="oldPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                </div>
                            </div>
                            <section class="add_account_error_messege" v-if="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.withdrawPassword" :key="index">
                                    <p class="wallet-error"> &#x2022; {{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>
                        <div class="acc-login-form-sec">
                            <label for="">{{ $t('confirm-withDraw-password', 'Confirm Withdraw Password') }} <span class="text-danger">*</span></label>
                            <div class="password-field-rel">
                                <input v-model="withdraw.c_password" :type="newPasswordFieldType"  class="form-control add password-input"
                                    @input="withdraw.c_password = $helper.sanitizeDetails('withdrawPassword', withdraw.c_password, 20); validate()" 
                                    :class="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmWithdrawPassword?.length > 0 ? 'error-input' :!withdraw.c_password?'Zindex': ''" />
                                    <span class="asterisk" v-if="!withdraw.c_password">{{ $t('enter-confirm-withdraw-password', 'Enter Confirm Withdraw Password') }} </span>

                                <div class="showHide-pass withdraw_pass" @click="togglePasswordVisibility('newPassword')">
                                    <img v-if="newPasswordFieldType === 'password'" src="@/assets/images/hide-pasword.webp" alt="show-pass" loading="lazy"/>
                                    <img v-else src="@/assets/images/show-pasword.webp" alt="show-pass"  loading="lazy"/>
                                    <!-- <i @click="togglePasswordVisibility('newPassword')" class="fa-solid" :class="newPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                </div>
                            </div>
                            <section class="add_account_error_messege" v-if="isOtpApiCalled && init.c_password && checkValidation?.confirmWithdrawPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.confirmWithdrawPassword" :key="index">
                                    <p class="wallet-error">&#x2022; {{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>
                        <div class="forgot-submit-btn">
                            <button @click="validateOtp()" class="btn submit-btn">{{$t('submit','Submit')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import validate from '@/modules/authorization/services/authValidation';
import {resetWithdrawalPassword, openWithdrawPasswordModal, startWithdrawTimer} from "../services/withdrawAccountDetails"

export default{
    name:'WithdrawalPasswordSetReset',
    emits:['openWithdrawPasswordModal'],
    data(){
        return{
            withdraw : {
                phone : '',
                otp : '',
                password : '',
                c_password : '',
            },
            isResentOtpBtnVisiable : false,
            startTime: null,
            endTime: null,
            timeLeft: 0,
            timer: null,
            validationErrors : null,
            init:{
                otp:false,
                c_password:false,
                password:false
            },
            isOtpApiCalled:false,
            oldPasswordFieldType : 'password',
            newPasswordFieldType: 'password',
        }
    },
    computed:{
        minutes() {
            return Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
        },
        seconds() {
            return (this.timeLeft % 60).toString().padStart(2, '0');
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    methods:{
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'oldPassword'){
                this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password';
            } else{
                this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        toggleInit(bool){
            this.init={
                otp:bool,
                c_password:bool,
                password:bool
            }
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'withdraw-password',
				this.withdraw.otp, 
				this.withdraw.password,
				this.withdraw.c_password,
            );
            return this.validationErrors;                                                                                                    
        },
        async resendOtp(){
            this.loading = true
            try {
                let response = await openWithdrawPasswordModal()
                this.loading = false
                if(!response?.error){
                    this.resetTimer()
                }
            } catch (error) {
                this.loading = false
                this.$errorToast(error);
            }
        },
        async startTimer() {
            startWithdrawTimer((data) => {
                this.isResentOtpBtnVisiable = data.isResentOtpBtnVisiable;
                this.timeLeft = data.timeLeft;
                this.timer = data.timer;
            });
        },
        stopTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
        },
        resetTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
            this.timeLeft = 5 * 60;
            this.startTimer();
        },
        async validateOtp() {
            this.toggleInit(true);
            if (Object.keys(this.validate())?.filter(key => !['newPassword', 'newUserId'].includes(key))?.length !== 0) return;
            const resetResponse = await this.resetWithdrawalPassword()

            if (resetResponse.error) {
                this.$errorToast(resetResponse?.error);
                if(resetResponse?.error?.[0]?.includes('OTP Expired')){
                    this.isResentOtpBtnVisiable = true;
                    clearInterval(this.timer);
                    this.timeLeft = 0;
                }
                return;
            }
            else {
                await this.resetWithdrawForm();
                this.$helper.closeModal('withdrawalPassword');
                this.resetTimer();
                // this.$successToast(resetResponse?.message);
            }
        },
        async resetWithdrawForm(){
            this.withdraw ={
                phone: '',
                otp: '',
                password: '',
                c_password: ''
            },
            this.isOtpApiCalled = false;
            this.validationErrors = null;
            this.toggleInit(false);
            this.oldPasswordFieldType = 'password';
            this.newPasswordFieldType= 'password';
        },
        async resetWithdrawalPassword(){
            if (!this.withdraw.password || this.withdraw.password == null) {
                this.$errorToast("New WithDraw Password Required!");
                return; 
            }
            if (this.withdraw.password != this.withdraw.c_password) {
                this.$errorToast("Confirm WithDraw Password Does Not Match With New WithDraw Password");
                return;
            }
            let data = {
                otp: this.withdraw.otp,
                password: this.withdraw.password,
            }
            console.log(data)

            let response = await resetWithdrawalPassword(data)
            if(response?.error) return {error : response.error}
            else return true
        },
        otpHasBeenCalled(){
            this.isOtpApiCalled = true;
        },
        assignWithdrawPhoneNumber(number){
            this.withdraw.phone = number
        }
    }
}
</script>

<style scoped>
.border-danger {
    border: 2px solid #dc3545 !important;
}
.text-danger .error-msg{
  color: #ff0000 !important;
}
.password-field-rel {
    position: relative;
}
.score-hide-show {
    position: absolute;
    top: 8px;
    right: 13px;
}
.score-hide-show img{
    max-width: 15px;
}
.withdraw-otp-row ,.password-field-rel .form-control, .password-field-rel .form-select{
    min-height: 35px;
    letter-spacing: 0;
    font-size: .8rem;
    color: #3e3999;
    position: relative;
    background: transparent;
    /* z-index: 2; */
}
.Zindex{
    z-index: 2;
}
</style>